import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { Dotcom2024Service } from '../dotcom2024.service';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PhoneNumberPipe } from '../phone-number.pipe';
import { MyharrellsService } from '../myharrells.service';
import { CanonicalService } from '../canonical.service';

@Component({
  selector: 'app-rep',
  standalone: true,
  imports: [CommonModule, FormsModule, PhoneNumberPipe],
  templateUrl: './rep.component.html',
  styleUrl: './rep.component.css'
})
export class RepComponent {

  constructor(private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public router: Router, public myHarrellsService: MyharrellsService, private canonicalService: CanonicalService) { }

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  locationsImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Locations/";
  marketsImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Markets/";
  employeePhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Employee-Photos/";
  blogImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Blog-Photos/";

  rep: any;

  zipCode: string;

  displayFailure: boolean = false;
  failureText: string = "";

  ngOnInit(): void {

    this.dotComService.activePage = "rep";

    //meta tags for SEO
    this.title.setTitle("meta title tag description here- rep");
    this.meta.updateTag({ name: 'description', content: "meta tag description here - rep" });
    this.meta.updateTag({ property: 'og:title', content: "og title here - rep" });
    this.meta.updateTag({ property: 'og:description', content: "og:description here - rep" });
    this.meta.updateTag({ property: 'og:image', content: "og:image here - rep" });
    this.meta.updateTag({ property: 'og:url', content: "og:url here - rep" });
    this.meta.updateTag({ property: 'Twitter:card', content: "twitter:card here - rep" });
    this.meta.updateTag({ property: 'Twitter:site', content: "twitter:site here - rep" });
    this.meta.updateTag({ property: 'Twitter:title', content: "twitter:title here - rep" });
    this.meta.updateTag({ property: 'Twitter:description', content: "twitter:description here - rep" });
    this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - rep" });
    // this.meta.updateTag({ name: 'author', content: "author tag here - rep" });
    // this.dotComService.createCanonicalURL();
    this.canonicalService.updateCanonicalURL(window.location.href);

    //get the rep details
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);

      let param = urlParams.get('id');
      let repId = parseInt(param);

      // this.dotComService.GetAllReps(repId).subscribe(reps => {

      if (this.dotComService.repsMasterList.length > 0) {
        //using the matter list of reps already bilt
        this.rep = this.dotComService.repsMasterList.filter(x => x.Id == repId);


        this.rep[0].FirstName = this.rep[0].FirstName.toLowerCase()
        this.rep[0].FirstName = this.rep[0].FirstName.charAt(0).toUpperCase() + this.rep[0].FirstName.slice(1);
        this.rep[0].LastName = this.rep[0].LastName.toLowerCase()
        this.rep[0].LastName = this.rep[0].LastName.charAt(0).toUpperCase() + this.rep[0].LastName.slice(1);

        //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
        this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.rep[0].Id + ".jpg", (exists) => {
          if (exists) {
            // Success code
            this.rep[0].EmployeePhoto = this.employeePhotosImagePaths + this.rep[0].Id + ".jpg"
          } else {
            // Fail code
            //this.dotComService.rep.EmployeePhoto = this.employeePhotosImagePaths + this.dotComService.rep.EmployeePhoto
            this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.rep[0].Id + ".png", (exists) => {
              if (exists) {
                // Success code
                this.rep[0].EmployeePhoto = this.employeePhotosImagePaths + this.rep[0].Id + ".png"
              } else {
                // Fail code - use default
                this.rep[0].EmployeePhoto = this.baseImagePaths + "harrellsh.png"
              }
            })
          }
        });
      }
      else {
        //if they come from the search page directly the master list would not have been built yet so get the data from the server
        this.dotComService.GetAllReps(repId).subscribe(reps => {
          this.dotComService.repsMasterList = reps;

          this.rep = this.dotComService.repsMasterList.filter(x => x.Id == repId);


          this.rep[0].FirstName = this.rep[0].FirstName.toLowerCase()
          this.rep[0].FirstName = this.rep[0].FirstName.charAt(0).toUpperCase() + this.rep[0].FirstName.slice(1);
          this.rep[0].LastName = this.rep[0].LastName.toLowerCase()
          this.rep[0].LastName = this.rep[0].LastName.charAt(0).toUpperCase() + this.rep[0].LastName.slice(1);


          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.rep[0].Id + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.rep[0].EmployeePhoto = this.employeePhotosImagePaths + this.rep[0].Id + ".jpg"
            } else {
              // Fail code
              //this.dotComService.rep.EmployeePhoto = this.employeePhotosImagePaths + this.dotComService.rep.EmployeePhoto
              this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + this.rep[0].Id + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.rep[0].EmployeePhoto = this.employeePhotosImagePaths + this.rep[0].Id + ".png"
                } else {
                  // Fail code - use default
                  this.rep[0].EmployeePhoto = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });

        })


      }


      // });
    }


    //get the blogs this person has written 
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);

      let param = urlParams.get('id');
      let repId = parseInt(param);

      this.dotComService.GetRepsActiveBlogs(repId).subscribe(blogs => {
        this.dotComService.resourceFilteredPosts = blogs;

        for (let i = 0; i < this.dotComService.resourceFilteredPosts.length; i++) {

          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg", (exists) => {
            if (exists) {
              // Success code
              this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
            } else {
              // Fail code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
              this.dotComService.checkIfImageExists(this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png", (exists) => {
                if (exists) {
                  // Success code
                  this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".png"
                } else {
                  // Fail code - use default
                  this.dotComService.resourceFilteredPosts[i].ImageName = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
        }
      })
    }
  }

  GoToBlog(blog) {
    this.router.navigateByUrl('/blog?id=' + blog.ItemAlias);
  }

  GetRepsFromZip() {
    this.zipCode = "33801"
    this.router.navigateByUrl('/findrep?zip=' + this.zipCode);
  }

  GetRepsFromCurrentLocation() {
    this.displayFailure = false;
    //get this locations zip then get the reps for that zip
    //if cant detect with location services (browser config says no bueno) user is prompted to enter zip code
    navigator.geolocation.getCurrentPosition((position) => {
      this.dotComService.GetLocationFromLatLon(position.coords.latitude, position.coords.longitude).subscribe(data => {
        if (data.results.length > 0) {
          for (let index = 0; index < data.results.length; index++) {
            const element = data.results[index];
            for (let indexR = 0; indexR < element.address_components.length; indexR++) {
              const elementR = element.address_components[indexR];
              if (elementR.types == "postal_code") {
                //populate the zip code in the zip code input box and trigger the submit button
                //this does the same thing as the user manually entering the zip code 
                this.zipCode = elementR.long_name;
                this.GetRepsFromZip()
                break;
              }
            }
          }
        }
        else {
          //should not have made it this far - zip not found in google result or the call failed
          //this.usersLocationdetected = true;
          this.displayFailure = true;
          this.failureText = "We were unable to determine your location. Please enter your zip code manually and press Submit.";
        }
      })
    }
      , (error) => {
        this.displayFailure = true;
        this.failureText = "We were unable to determine your location. Please make sure you have location services enabled on your browser.  Alternatively, you can enter your zip code manually and press Submit.";
      }
    );
  }

  HideFailureAlert() {
    this.displayFailure = false;
  }

}
